import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/game/[slug]/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/badge/badge-factory.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NumberedBadge"] */ "/app/src/app/components/badge/layouts/numbered/numbered-badge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/badge/layouts/social-tag/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/badge/layouts/text/text-badge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game-badge-image/game-badge-image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game-info-details/game-info-labels.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/daily-jackpot/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/simplified-row/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/trending/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/animated-trailer/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/layouts/default/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/animated-tile/animated-tile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotAmountAndTime"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-amount-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotDescription"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-description.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/details/game-details.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/game-url/game-url.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/info-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/swj-border-overlay/swj-border-overlay.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/metadata-info-section/metadata-info-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VolatilityInfoPopup"] */ "/app/src/app/components/popup/layouts/volatility-info-popup/volatility-info-popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/app/src/app/components/rich-text/rich-text.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/site-wide-jackpot/subcomponents/jackpot-ticker/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/elements/favorites-button/favorites-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/elements/svg/icons/chevron-up.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/app/elements/video/video.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
